// =====================================================================
// Supabase client — single source of truth.
// =====================================================================
// Все компоненты должны импортировать `supabase` отсюда, а не из window.
// Anon key — public (RLS защищает данные). Service-role keys никогда сюда
// не попадают — они только в server-side env (Vercel Edge Functions, GH Actions).
//
// PKCE-флаги обязательны: см. R-13 audit 2026-04-20.
// =====================================================================

import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL      = import.meta.env.VITE_SUPABASE_URL
                       || 'https://suvmndafexpyzyivvjcu.supabase.co';
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY
                       || 'sb_publishable_vrvtuejoL5YL9RHPTsFAGw_gZ3fC39A';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    flowType: 'pkce',
    detectSessionInUrl: true,
    persistSession: true,
    autoRefreshToken: true,
    storageKey: 'freedomos-sb-auth',
  },
});

// Backward-compat: некоторые места кода (особенно во время миграции)
// могут ещё ссылаться на window.__supabase. После полного перехода на
// импорты — удалить эту строку.
if (typeof window !== 'undefined') {
  window.__supabase = supabase;
}
